import { useMatch } from "react-router-dom";
import Whatsapp from 'styles/images/svg/whatsapp.svg';
import Rubika from 'styles/images/png/rubika.png';
import sharedStyles from 'styles/css/SharedStyles.module.scss';

const SupportIcons = () => {

	const isVisitHistoryPage = useMatch("/visit-history/:uniqueCode");

    if (isVisitHistoryPage) {
        return null; // آیکن نمایش داده نمی‌شود
    }

    return (
        <div id={'segment-support-icons'} className={sharedStyles['container-wraper']}>
        	<div className={sharedStyles['support-segment']}>
            	{/*<a href="https://wa.me/+989020843320">
            		<img src={Whatsapp} width={60} className={sharedStyles['cursor-pointer']} alt="تماس در واتس اپ" />
            	</a>*/}
            	<a href="https://wa.me/+989171020676">
            		<img src={Whatsapp} width={60} className={sharedStyles['cursor-pointer']} alt="تماس در واتس اپ" />
            	</a>
            </div>

            <div className={sharedStyles['support-segment-left']}>
                <a href="https://rubika.ir/dr20_org" target="_blank" rel="noopener noreferrer">
                    <img src={Rubika} width={60} className={sharedStyles['cursor-pointer']} alt="تماس در روبیکا" style={{maxHeight: "60px", objectFit: "contain"}} />
                </a>
            </div>
        </div>
    );
}

export default SupportIcons;
